import { HStack, Box, Text } from '@chakra-ui/react';
import { DeleteDangerIcon, FileTypeIcon } from '@halo/ui-chat-react';
import { formatFileSize } from '@halo/utils';

function FileItem({ file, handleDelete }: { file: File; handleDelete: (file: File) => void }) {
  return (
    <HStack w="full" justify="space-between" alignItems="center" py="2">
      <HStack gap="2.5" flex="1" minW="0">
        <FileTypeIcon extType={file.name.split('.').pop()!} file={file} />
        <Box overflow="hidden">
          <Text lineClamp="1" width="full" fontWeight="semibold" fontSize="sm">
            {file?.name}
          </Text>
          <Text mt="0.5" fontWeight="medium" fontSize="sm" color="fg.muted">
            {formatFileSize(file?.size)}
          </Text>
        </Box>
      </HStack>
      <Box width="18px" height="18px" userSelect="none">
        <DeleteDangerIcon cursor="pointer" onClick={() => handleDelete?.(file)} />
      </Box>
    </HStack>
  );
}

const MemoizedImageUploader = memo(FileItem);

export { MemoizedImageUploader as FileItem };
